export default function DevelopmentTable() {
    return (
        <div>
            <table>
                <thead>
                <tr>
                    <th>Subdomain</th>
                    <th>Favorites</th>
                    <th>Worked before</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Backend Development</td>
                    <td>Django, Streamlit</td>
                    <td>Flask</td>
                </tr>
                <tr>
                    <td>Frontend Development</td>
                    <td>React, Vanilla JS</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>DevOps</td>
                    <td>AWS, DigitalOcean</td>
                    <td>Azure, Google Cloud</td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}